




































import Vue from "vue";
import Component from "vue-class-component";
import { RiskProfileStore, LoadingSpinnerService } from "@/store";
import { RiskProfileQuestionDto } from "@/api/ClientPortalApiClient";
import RiskProfileQuestion from "./RiskProfileQuestion.vue";
import BackButton from "@/components/BackButton.vue";
import AlertService from "@/services/alert.service";
import router, { ROUTES } from "@/router";

@Component({
  name: "risk-profiler",
  components: {
    RiskProfileQuestion,
    BackButton
  }
})
export default class RiskProfiler extends Vue {
  questions: RiskProfileQuestionDto[] = [];
  submitted: boolean = false;

  async created() {
    LoadingSpinnerService.Show("Loading risk profile...");
    await RiskProfileStore.LoadRequests();

    if (RiskProfileStore.ProfileIsComplete) {
      LoadingSpinnerService.Hide();
      router.push({ name: ROUTES.riskprofilerresults });
    } else {
      var success = await RiskProfileStore.LoadQuestions();
      if (success) {
        this.questions = RiskProfileStore.Questions;
        LoadingSpinnerService.Hide();
      } else {
        LoadingSpinnerService.Failure(
          "Unable to load the Risk Profiler. Please try again."
        );
      }
    }
  }

  async submit() {
    this.submitted = true;
    if (RiskProfileStore.AllQuestionsAnswered) {
      LoadingSpinnerService.Show("Calculating your risk score...");
      const result = await RiskProfileStore.CompleteQuestionnaire();
      if (result) {
        LoadingSpinnerService.Hide();
        router.push({ name: ROUTES.riskprofilerresults });
      } else {
        LoadingSpinnerService.Failure("Failed to Save Risk Profile");
      }
    } else {
      // display validation error
      var alertService = new AlertService();
      alertService.warn(
        "Unable to Calculate Your Risk Score",
        "Please provide an answer for all questions."
      );
    }
  }

  get contactName(): string {
    return RiskProfileStore.SelectedRequest.contactFullName || "";
  }
}
